import { graphql, useLazyLoadQuery } from 'react-relay';
import {
  FilteredSurveyInput,
  useDashboardQuery as useDashboardQueryType,
} from './__generated__/useDashboardQuery.graphql';

const dashboardQuery = graphql`
  query useDashboardQuery($input: FilteredSurveyInput!, $first: Int) {
    walletBalance {
      ...RedeemBanner_balance
      amount {
        subUnitAmount
        currency
        formatted
      }
    }
    targetRedemptionValue {
      ...RedeemBanner_target
    }
    surveys(input: $input) {
      pageInfo {
        totalCount
      }
    }
    ...useSurveyListFragmentQuery_surveysRef @arguments(input: $input)
    ...useMoreSurveysBannerQuery_profileUrlRef
    consentSettings {
      ...TermsAndConditionsConsent_consentSettings
    }
    ...useNoSurveysFragmentQuery_noSurveysRef
    profilerUrl
    signupSurveyUrl
    notificationSubscriptions {
      surveyInviteContactChannels
    }
    deals(first: $first) {
      edges {
        node {
          id
          title
          description
          imageUrl
          desktopImageUrl
          guid
          advertiser {
            name
            imageUrl
          }
          tags
          paysReward
          rewardLabel
        }
      }
    }
    desktopCashbacks(first: $first) {
      edges {
        node {
          id
          title
          description
          imageUrl
          desktopImageUrl
          guid
          advertiser {
            name
            imageUrl
          }
          tags
          paysReward
          rewardLabel
          id
        }
      }
    }
    userData {
      firstName
    }
    ...useMoreSurveysBannerQuery_profileUrlRef
    history {
      id
      status
      earningBreakdown {
        type
        label
        amount {
          cents
          currency
          formatted
        }
      }
      cashoutBreakdown {
        type
        label
        amount {
          cents
          currency
          formatted
        }
      }
      monthlyEarnings {
        date
        type
        amount {
          cents
          currency
          formatted
        }
      }
    }
    blogPosts(first: $first) {
      edges {
        node {
          ...BlogPostItem_item
          id
        }
      }
    }
    polls {
      id
      pageInfo {
        totalCount
      }
      edges {
        node {
          id
          startDate
          answerTime
          description {
            title
            subtitle
            imageUrl
            iconUrl
          }
          possibleAnswers {
            type
            ... on SelectionQuestionAnswers {
              answers {
                answerKey
                label
              }
            }
            ... on MultiPunchQuestionAnswers {
              answers {
                answerKey
                label
              }
            }
          }
          responseStatistics {
            key
            ratio
            correct
            selected
          }
          reward {
            cents
            currency
            formatted
          }
          userResponse {
            id
            answerKeys
            label
          }
        }
      }
    }
  }
`;

export function useDashboardQuery(variables: { input: FilteredSurveyInput; first?: number }) {
  return useLazyLoadQuery<useDashboardQueryType>(dashboardQuery, variables, {
    fetchPolicy: 'store-or-network',
  });
}
